/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/ 

// Insert any custom theme js here...    

$(document).ready(function() {
  
      if ($(".options-selection__option-value-name")[0]){
              $(".product__add-to-cart-button").hide();
              $(".options-selection__option-value-name").click(function(){
                $(".product__add-to-cart-button").show();
              $(".select_val").hide();
                //alert('ad03');          
        });
      } else { $(".select_val").hide(); }
      
       $(document).ready(function() {
        if (window.location.href.indexOf("variant") > -1) {
          $(".product__add-to-cart-button").show();
          $(".select_val").hide();
        }
         else{
         <!-- initial load no variants selected check -->  
         $('.product-form__item input[type=radio]').prop('checked', false);
         }
      });
  });


document.addEventListener("DOMContentLoaded",
function() {
            var div, n,
                v = document.getElementsByClassName("youtube-player");
            for (n = 0; n < v.length; n++) {
                div = document.createElement("div");
                div.setAttribute("data-id", v[n].dataset.id);
                div.innerHTML = labnolThumb(v[n].dataset.id);
                div.onclick = labnolIframe;
                v[n].appendChild(div);
            }
        });

function labnolThumb(id) {
        var thumb = '<img data-src="https://i.ytimg.com/vi/ID/hqdefault.jpg" class="lazyload" alt="video thumbnail">', 
            play = '<div class="play"></div>';
        return thumb.replace("ID", id) + play;
    }

function labnolIframe() {
        var iframe = document.createElement("iframe");
        var embed = "https://www.youtube.com/embed/ID?autoplay=1&rel=0";
        iframe.setAttribute("src", embed.replace("ID", this.dataset.id));
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("allowfullscreen", "1");
        this.parentNode.replaceChild(iframe, this);
    }


/* HC - back in stock form - 21 Oct '19 */
$(document).ready(function() {

  var url = window.location.href;

  if (url.indexOf("contact_posted=true") >= 0){  
    $('.hc-email').hide();
    $('.accent-text').show();
    $('#sold-out').show();
    $('#notify-me-wrapper').hide();
  }
});
var sections = window.theme.sections;
var slideshowAutoExtension = {
  init: function() {
    this.on('slideshow_desktop_init_done', this._autoplaySlideshow.bind(this));
  },
  _autoplaySlideshow: setInterval(function() {
    var $slide = $('.slideshow__slide--active')
                   .removeClass('slideshow__slide--active');

    var $button = $('.slideshow__button--active')
                   .removeClass('slideshow__button--active');

    var $slides = $('.slideshow__slide');

    var currentIndex = ($slides.index($slide) + 1) % $slides.length;

    $slides
      .eq(currentIndex)
      .addClass('slideshow__slide--active');

    var $buttons = $('.slideshow__button')
      .eq(currentIndex)
      .addClass('slideshow__button--active');

  }, 5000)

};

sections.extend('slideshow', slideshowAutoExtension);
//HC adding pick an option 25 May '20 
document.addEventListener('DOMContentLoaded', function() {
   if( typeof(productOptions ) != "undefined" ){
    for(i=0;i<productOptions.length;i++) {
      $('.single-option-selector:eq('+ i +')')
      .filter(function() {
        return $(this).find('option').length > 1
      })
      .prepend(`<option value="-1">Select to see ${productOptions[i][i].toLowerCase()}s available </option>`)
      .val('-1')
      .trigger('change');
    }
  }
  $('body').on('click',function(e){
    //alert('ss');
    if(e.target.classList.contains('product__add-to-cart-button')){
    	let valueSelector = $('.single-option-selector').val();
      	if(valueSelector !== '-1'){
      		$(this).trigger('click')
            $('.hc-danger').hide();
        }else{
          	$('.hc-danger').show();
        	return false
        } 
    } //alert('s3');
  })
  $('.single-option-selector').on('change',function(){
    let valueSelector = $(this).val();
    if(valueSelector !== '-1')
    {
    	$('.hc-danger').hide();
      	$('.product__add-to-cart-button').removeAttr('disabled');
    }else{
    	$('.hc-danger').show();
      	$('.product__add-to-cart-button').attr('disabled');
    }
  })
})

// HC - 19 Jan '21 - search toggle
$(function(){
  $(".head-search-toggle").click(function(ev){
    ev.preventDefault();
    $(this).parent().find(".hc-search-wrap").toggleClass("hc-search-active");
  });
  
  $('.hc-search-wrap .input-group__btn button.btn[type="submit"]').click(function(ev){
    ev.preventDefault();
    $(".hc-search-wrap").toggleClass("hc-search-active");
  });
});